
  import { computed, defineComponent } from 'vue';
  import { Button, Hint, Icon, Typography } from '@voximplant/spaceui';
  import CallInfo from '@/components/calls/CallInfo.vue';
  import { $settings, changeVideoMute } from '@/store/settings/index';
  import { useStore } from 'effector-vue/composition';
  import { useI18n } from 'vue-i18n';
  import Loading from '@/components/animation/Loading.vue';
  import {
    $callDuration,
    incomingCalls,
    answerIncomingCall,
    hangUp,
    toggleLocalVideo,
    setCurrentCallAsPaused,
    $currentActiveCallId,
  } from '@/store/calls';
  import { changeVideoParam } from '@/lib/sdkSource';
  import appConfig from '@/config';
  import { debounce } from "@/helper/debounce";

  export default defineComponent({
    name: 'IncomingCall',
    components: { Loading, CallInfo, Typography, Button, Icon, Hint },
    setup() {
      const { t } = useI18n();
      const settingsState = useStore($settings);
      const duration = useStore($callDuration);
      const incomingCallsStore = useStore(incomingCalls);
      const currentActiveCallId = useStore($currentActiveCallId);
      const currentIncomingCall = computed(() => incomingCallsStore.value[0]);

      const buttonWrapClasses = computed(() => ({
        video: currentIncomingCall.value.video,
        audio: !currentIncomingCall.value.video,
      }));

      const answerCall = debounce((isVideo: boolean) => {
        if (currentActiveCallId.value) {
          setCurrentCallAsPaused({})
            .then(() => answer(isVideo))
            .catch((error) => console.error('setCurrentCallAsPaused error', error));
        } else {
          answer(isVideo);
        }
      }, 600);

      const answer = (isVideo: boolean) => {
        if (currentIncomingCall.value) {
          toggleLocalVideo({ id: currentIncomingCall.value.id, status: isVideo });
          if (settingsState.value.videoMute !== isVideo) changeVideoParam(isVideo)
          else changeVideoMute(!isVideo);
        }
        answerIncomingCall({ id: currentIncomingCall.value.id, isVideo });
      };

      return {
        t,
        incomingCallsStore,
        currentIncomingCall,
        hangUp,
        settingsState,
        answerIncomingCall,
        duration,
        buttonWrapClasses,
        appConfig,
        answerCall,
      };
    },
  });
